import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, MailIcon, LockIcon, EyeIcon, EyeOffIcon, CheckCircleIcon, BriefcaseIcon, CalendarIcon, UserPlusIcon, BuildingIcon, UsersIcon, InfoIcon } from 'lucide-react';
const SellerLogin = () => {
  const [activeTab, setActiveTab] = useState('login');
  const [userType, setUserType] = useState<'buyer' | 'seller'>('seller');
  const [showPassword, setShowPassword] = useState(false);
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });
  const [registerData, setRegisterData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    accountType: 'organizer',
    businessName: '',
    phoneNumber: '',
    termsAccepted: false
  });
  const handleLoginChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setLoginData({
      ...loginData,
      [name]: value
    });
  };
  const handleRegisterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value,
      type
    } = e.target as HTMLInputElement;
    setRegisterData({
      ...registerData,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value
    });
  };
  const handleLoginSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    alert(`${userType === 'buyer' ? 'Buyer' : 'Seller'} login successful!`);
  };
  const handleRegisterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (registerData.password !== registerData.confirmPassword) {
      alert('Passwords do not match!');
      return;
    }
    alert(`Registration successful! Welcome to JoinToday.co.ke as a ${registerData.accountType}!`);
  };
  return <div className="p-4 pb-20 max-w-4xl mx-auto" data-id="element-3358">
      <div className="flex justify-between items-center mb-6" data-id="element-3359">
        <h1 className="text-2xl font-bold" data-id="element-3360">
          {userType === 'buyer' ? 'Reader/Buyer Account' : 'Seller/Contributor Account'}
        </h1>
        <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-3361">
          <button onClick={() => setUserType('buyer')} className={`px-3 py-1 text-sm ${userType === 'buyer' ? 'bg-gray-800 text-white' : 'bg-white'}`} data-id="element-3362">
            Reader/Buyer
          </button>
          <button onClick={() => setUserType('seller')} className={`px-3 py-1 text-sm ${userType === 'seller' ? 'bg-gray-800 text-white' : 'bg-white'}`} data-id="element-3363">
            Seller/Contributor
          </button>
        </div>
      </div>
      {userType === 'seller' && <div className="border border-gray-300 rounded-lg p-6 mb-6 bg-gray-50" data-id="element-3364">
          <h2 className="text-lg font-medium mb-3" data-id="element-3365">Become a Contributor</h2>
          <p className="text-sm text-gray-600 mb-4" data-id="element-3366">
            Join our platform as a contributor and start monetizing your events,
            content, and influence.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3367">
            <div className="border border-gray-200 rounded-md p-4 bg-white" data-id="element-3368">
              <div className="flex items-center mb-2" data-id="element-3369">
                <CalendarIcon className="w-5 h-5 mr-2 text-gray-700" data-id="element-3370" />
                <h3 className="font-medium" data-id="element-3371">Event Organizer</h3>
              </div>
              <p className="text-xs text-gray-600 mb-2" data-id="element-3372">
                Create and manage events, sell tickets, and grow your audience.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-3373">
                <li className="flex items-start" data-id="element-3374">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3375" />
                  <span data-id="element-3376">15% commission on ticket sales</span>
                </li>
                <li className="flex items-start" data-id="element-3377">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3378" />
                  <span data-id="element-3379">Promotion across our platform</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-md p-4 bg-white" data-id="element-3380">
              <div className="flex items-center mb-2" data-id="element-3381">
                <UserPlusIcon className="w-5 h-5 mr-2 text-gray-700" data-id="element-3382" />
                <h3 className="font-medium" data-id="element-3383">Event Influencer</h3>
              </div>
              <p className="text-xs text-gray-600 mb-2" data-id="element-3384">
                Promote events and earn commission on ticket sales through your
                network.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-3385">
                <li className="flex items-start" data-id="element-3386">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3387" />
                  <span data-id="element-3388">5% commission on referred sales</span>
                </li>
                <li className="flex items-start" data-id="element-3389">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3390" />
                  <span data-id="element-3391">Unique referral tracking</span>
                </li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-md p-4 bg-white" data-id="element-3392">
              <div className="flex items-center mb-2" data-id="element-3393">
                <BuildingIcon className="w-5 h-5 mr-2 text-gray-700" data-id="element-3394" />
                <h3 className="font-medium" data-id="element-3395">Venue Partner</h3>
              </div>
              <p className="text-xs text-gray-600 mb-2" data-id="element-3396">
                List your venue and connect with event organizers looking for
                spaces.
              </p>
              <ul className="text-xs text-gray-600 space-y-1" data-id="element-3397">
                <li className="flex items-start" data-id="element-3398">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3399" />
                  <span data-id="element-3400">Direct booking inquiries</span>
                </li>
                <li className="flex items-start" data-id="element-3401">
                  <CheckCircleIcon className="w-3 h-3 mr-1 mt-0.5 text-gray-700" data-id="element-3402" />
                  <span data-id="element-3403">Featured venue listings</span>
                </li>
              </ul>
            </div>
          </div>
        </div>}
      <div className="border border-gray-300 rounded-lg overflow-hidden" data-id="element-3404">
        <div className="flex border-b border-gray-300" data-id="element-3405">
          <button onClick={() => setActiveTab('login')} className={`flex-1 py-3 text-center ${activeTab === 'login' ? 'bg-gray-100 font-medium' : ''}`} data-id="element-3406">
            Login
          </button>
          <button onClick={() => setActiveTab('register')} className={`flex-1 py-3 text-center ${activeTab === 'register' ? 'bg-gray-100 font-medium' : ''}`} data-id="element-3407">
            Register
          </button>
        </div>
        <div className="p-6" data-id="element-3408">
          {activeTab === 'login' ? <form onSubmit={handleLoginSubmit} data-id="element-3409">
              <div className="mb-4" data-id="element-3410">
                <label className="block text-sm font-medium mb-1" data-id="element-3411">Email</label>
                <div className="relative" data-id="element-3412">
                  <input type="email" name="email" value={loginData.email} onChange={handleLoginChange} className="w-full p-2 pl-9 border border-gray-300 rounded-md" required data-id="element-3413" />
                  <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3414" />
                </div>
              </div>
              <div className="mb-4" data-id="element-3415">
                <label className="block text-sm font-medium mb-1" data-id="element-3416">
                  Password
                </label>
                <div className="relative" data-id="element-3417">
                  <input type={showPassword ? 'text' : 'password'} name="password" value={loginData.password} onChange={handleLoginChange} className="w-full p-2 pl-9 pr-9 border border-gray-300 rounded-md" required data-id="element-3418" />
                  <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3419" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-3420">
                    {showPassword ? <EyeOffIcon className="w-4 h-4 text-gray-500" data-id="element-3421" /> : <EyeIcon className="w-4 h-4 text-gray-500" data-id="element-3422" />}
                  </button>
                </div>
              </div>
              <div className="flex justify-between items-center mb-4" data-id="element-3423">
                <label className="flex items-center" data-id="element-3424">
                  <input type="checkbox" className="mr-2" data-id="element-3425" />
                  <span className="text-sm" data-id="element-3426">Remember me</span>
                </label>
                <button type="button" className="text-sm text-gray-600 hover:underline" data-id="element-3427">
                  Forgot password?
                </button>
              </div>
              <button type="submit" className="w-full bg-gray-800 text-white rounded-md py-2 text-sm mb-4" data-id="element-3428">
                Login
              </button>
              <p className="text-center text-sm text-gray-600" data-id="element-3429">
                Don't have an account?{' '}
                <button type="button" onClick={() => setActiveTab('register')} className="text-gray-800 hover:underline" data-id="element-3430">
                  Register
                </button>
              </p>
            </form> : <form onSubmit={handleRegisterSubmit} data-id="element-3431">
              <div className="mb-4" data-id="element-3432">
                <label className="block text-sm font-medium mb-1" data-id="element-3433">
                  Full Name
                </label>
                <div className="relative" data-id="element-3434">
                  <input type="text" name="name" value={registerData.name} onChange={handleRegisterChange} className="w-full p-2 pl-9 border border-gray-300 rounded-md" required data-id="element-3435" />
                  <UserIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3436" />
                </div>
              </div>
              <div className="mb-4" data-id="element-3437">
                <label className="block text-sm font-medium mb-1" data-id="element-3438">Email</label>
                <div className="relative" data-id="element-3439">
                  <input type="email" name="email" value={registerData.email} onChange={handleRegisterChange} className="w-full p-2 pl-9 border border-gray-300 rounded-md" required data-id="element-3440" />
                  <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3441" />
                </div>
              </div>
              <div className="mb-4" data-id="element-3442">
                <label className="block text-sm font-medium mb-1" data-id="element-3443">
                  Phone Number
                </label>
                <input type="tel" name="phoneNumber" value={registerData.phoneNumber} onChange={handleRegisterChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-3444" />
              </div>
              {userType === 'seller' && <>
                  <div className="mb-4" data-id="element-3445">
                    <label className="block text-sm font-medium mb-1" data-id="element-3446">
                      Account Type
                    </label>
                    <select name="accountType" value={registerData.accountType} onChange={handleRegisterChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-3447">
                      <option value="organizer" data-id="element-3448">Event Organizer</option>
                      <option value="influencer" data-id="element-3449">Event Influencer</option>
                      <option value="venue" data-id="element-3450">Venue Partner</option>
                    </select>
                  </div>
                  <div className="mb-4" data-id="element-3451">
                    <label className="block text-sm font-medium mb-1" data-id="element-3452">
                      Business/Organization Name
                    </label>
                    <div className="relative" data-id="element-3453">
                      <input type="text" name="businessName" value={registerData.businessName} onChange={handleRegisterChange} className="w-full p-2 pl-9 border border-gray-300 rounded-md" required data-id="element-3454" />
                      <BuildingIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3455" />
                    </div>
                  </div>
                </>}
              <div className="mb-4" data-id="element-3456">
                <label className="block text-sm font-medium mb-1" data-id="element-3457">
                  Password
                </label>
                <div className="relative" data-id="element-3458">
                  <input type={showPassword ? 'text' : 'password'} name="password" value={registerData.password} onChange={handleRegisterChange} className="w-full p-2 pl-9 pr-9 border border-gray-300 rounded-md" required data-id="element-3459" />
                  <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-3460" />
                  <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-3461">
                    {showPassword ? <EyeOffIcon className="w-4 h-4 text-gray-500" data-id="element-3462" /> : <EyeIcon className="w-4 h-4 text-gray-500" data-id="element-3463" />}
                  </button>
                </div>
              </div>
              <div className="mb-4" data-id="element-3464">
                <label className="block text-sm font-medium mb-1" data-id="element-3465">
                  Confirm Password
                </label>
                <input type={showPassword ? 'text' : 'password'} name="confirmPassword" value={registerData.confirmPassword} onChange={handleRegisterChange} className="w-full p-2 border border-gray-300 rounded-md" required data-id="element-3466" />
              </div>
              <div className="mb-4" data-id="element-3467">
                <label className="flex items-start" data-id="element-3468">
                  <input type="checkbox" name="termsAccepted" checked={registerData.termsAccepted} onChange={handleRegisterChange} className="mr-2 mt-1" required data-id="element-3469" />
                  <span className="text-sm" data-id="element-3470">
                    I agree to the{' '}
                    <button type="button" onClick={() => alert('Terms & Conditions')} className="text-gray-800 hover:underline" data-id="element-3471">
                      Terms & Conditions
                    </button>{' '}
                    and{' '}
                    <button type="button" onClick={() => alert('Privacy Policy')} className="text-gray-800 hover:underline" data-id="element-3472">
                      Privacy Policy
                    </button>
                  </span>
                </label>
              </div>
              {userType === 'seller' && <div className="mb-4 p-3 border border-gray-200 rounded-md bg-gray-50 flex items-start" data-id="element-3473">
                  <InfoIcon className="w-4 h-4 text-gray-700 mr-2 mt-0.5" data-id="element-3474" />
                  <p className="text-xs text-gray-600" data-id="element-3475">
                    By registering as a {registerData.accountType}, you agree to
                    our commission structure and seller terms. Your account will
                    be reviewed within 24-48 hours before activation.
                  </p>
                </div>}
              <button type="submit" className="w-full bg-gray-800 text-white rounded-md py-2 text-sm mb-4" data-id="element-3476">
                Register
              </button>
              <p className="text-center text-sm text-gray-600" data-id="element-3477">
                Already have an account?{' '}
                <button type="button" onClick={() => setActiveTab('login')} className="text-gray-800 hover:underline" data-id="element-3478">
                  Login
                </button>
              </p>
            </form>}
        </div>
      </div>
    </div>;
};
export default SellerLogin;